import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import BlogRelatedCard from "./relatedCard";
import { Col, Container, Row } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { FiArrowLeft, FiClock, FiShare2 } from "react-icons/fi";

function DetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]); // Fixed initial state to empty array
  const [metaData, setMetaData] = useState({});
  const { config } = useSiteConfig();

  const fetchBlogsDetail = async () => {
    try {
      const params = { limit: 4 };
      const res = await blogAPI.details(slug, params);

      if (res.code === 200) {
        const { blog, relatedBlogs: related } = res.data;
        setItem(blog);
        setRelatedBlogs(related || []);
        setMetaData(blog?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.title} middle="" />
      <SEO meta={metaData} />

      <div className="premium-detail-page-funky">
        {/* SECTION 1: ASYMMETRIC ASYNC HERO */}
        <section className="hero-split-editorial">
          <div className="hero-text-side-box">
            <div className="content-inner-editorial">
              <span className="category-label-top-sticker">THE HERITAGE SERIES</span>
              <h1 className="main-display-title-editorial">{item?.title}</h1>
              <p className="intro-subtitle-editorial">{item?.shortDescription}</p>
              
              <div className="author-info-box-editorial">
                <div className="blog-badge-circle-funky">
                  {getInitials(item?.author)}
                </div>
                <div className="author-meta-text">
                  <h6>BY {item?.author || "EDITORIAL TEAM"}</h6>
                  <span><FiClock className="me-1"/>{formatDate(item?.date)}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-image-side-box">
            <img src={item?.image} alt={item?.title || "Jewelry Story"} />
          </div>
        </section>

        {/* SECTION 2: EDITORIAL RICH CONTENT */}
        <Container className="py-5 mt-4">
          <Row className="justify-content-center g-5">
            {/* LEFT BAR: STICKY SOCIALS ACCENT */}
            <Col lg={2} className="d-none d-lg-block">
              <div className="sticky-socials-funky">
                <span className="share-title"><FiShare2 size={14} className="me-1"/> SHARE</span>
                <div className="brutal-divider-line"></div>
                <ul className="socials-list-unstyled">
                  {config?.socialMedia?.facebook && (
                    <li>
                      <a href={config?.socialMedia?.facebook} target="_blank" rel="noreferrer" className="social-icon-sticker">
                        <FaFacebook size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.instagram && (
                    <li>
                      <a href={config?.socialMedia?.instagram} target="_blank" rel="noreferrer" className="social-icon-sticker">
                        <FaInstagram size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.twitter && (
                    <li>
                      <a href={config?.socialMedia?.twitter} target="_blank" rel="noreferrer" className="social-icon-sticker">
                        <FaTwitter size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.youtube && (
                    <li>
                      <a href={config?.socialMedia?.youtube} target="_blank" rel="noreferrer" className="social-icon-sticker">
                        <FaYoutube size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.linkedin && (
                    <li>
                      <a href={config?.socialMedia?.linkedin} target="_blank" rel="noreferrer" className="social-icon-sticker">
                        <FaLinkedin size={16} />
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </Col>

            {/* CENTER PANEL: RICH HTML ARTICLE TEXT */}
            <Col lg={7} className="article-body-editorial">
              <div className="drop-cap-html-wrapper mb-5">
                <div dangerouslySetInnerHTML={{ __html: item?.description }} />
              </div>

              {/* RELATED STORIES LISTING */}
              {relatedBlogs && relatedBlogs.length > 0 && (
                <div className="related-blogs-section mt-5 pt-4">
                  <h3 className="related-section-title">RELATED STORIES</h3>
                  <div className="row g-3 mt-2">
                    {relatedBlogs.map((blog, index) => (
                      <div key={blog._id || index} className="col-12">
                        <BlogRelatedCard item={blog} />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* FOOTER ACTION BACKLINK */}
              <div className="d-flex justify-content-center mt-5 pt-3 border-top-dashed">
                <Link to='/blog' className="view-all-blog-funky-btn">
                  <FiArrowLeft className="me-2"/> BACK TO JOURNAL
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default DetailPage;